import { Component, OnInit, Input } from '@angular/core';
import { ParentEducationMoment } from 'src/app/models/parent-education-moment';

@Component({
  selector: 'app-pem-detail',
  templateUrl: './pem-detail.component.html',
  styleUrls: ['./pem-detail.component.scss']
})
export class PemDetailComponent implements OnInit {

  _pem: ParentEducationMoment = ParentEducationMoment.defaults()
  get pem(): ParentEducationMoment { return this._pem }
  @Input() set pem(pem: ParentEducationMoment) { this._pem = pem ||  ParentEducationMoment.defaults() }

  constructor() { }

  ngOnInit() {
  }

  // TODO: move this into a shared collection of css utilities
  textareaHeight(id: string, minHeight: number): string {
    // I was using AutosizeModule (https://github.com/chrum/ngx-autosize) but it was giving the
    // elements way too much height. Clearly a bug. Decided to roll my own.
    // https://stackoverflow.com/questions/50762433/resizetextarea-in-angular-5
    const textArea = document.getElementById(id)
    if (!textArea) {
      return minHeight + 'px'
    }
    textArea.style.overflow = 'hidden'
    // textArea.style.height = 'auto'   // this is part of the documented solution, but causes the Notes field to jump (Safari)
    textArea.style.height = Math.max(minHeight, textArea.scrollHeight) + 'px'
    return textArea.style.height
  }
}
